export const authConfigs = {
    meEndpoint: '/user',
    loginEndpoint: '/auth/signin',
    registerEndpoint: '/auth/signup',
    logoutEndpoint: '/auth/signout',
    requestPasswordEndpoint: '/auth/pwreset',
    resetPasswordEndpoint: '/auth/newpw',
    storageTokenKeyName: 'connect.sid',
}
